// extracted by mini-css-extract-plugin
export var card = "productList-module--card--2cd9d";
export var meta = "productList-module--meta--e6d3b";
export var msg = "productList-module--msg--74810";
export var priceContainer = "productList-module--priceContainer--9dd34";
export var productDescription = "productList-module--productDescription--14942";
export var productPrice = "productList-module--productPrice--2c855";
export var productname = "productList-module--productname--e6626";
export var regularPrice = "productList-module--regularPrice--7f410";
export var specialPrice = "productList-module--specialPrice--d3908";
export var uppercase = "productList-module--uppercase--6f832";
export var warningMessage = "productList-module--warningMessage--0192a";